import PropTypes from 'prop-types';

import useResponsive from '../../../../utils/responsive';

import { FadeInAnimation, Shapes } from '../../shared';

import Image from '../../shared/image.component';



const MobileAppSection = (props) => {    
    const { isMobile, isTablet } = useResponsive();
    const { imgAlt, imgSrc } = props;

    const renderImageSectionDesktop = () => {
        if (!isMobile || !isTablet) {
            return (
                <>
                    <Shapes
                        isPair
                        isDark
                        degrees="-26.87deg"
                        speed={0.08}
                        smallMargins={{ width: 125.51, height: 62.76 }}
                        largeMargins={{ width: 215.88, height: 107.94 }}
                        distanceBetween={{ width: '0%', height: '15%' }}
                        containerMargins={{ left: '-10%', top: '15%' }}
                        zIndex={0}
                    />
                    <Image className='mobile-app-section-icon-message' src="/assets/images/message-icon.png" alt={imgAlt} isOldImage />
                    <Image className='mobile-app-section-icon-image' src="/assets/images/wallet-icon.png" alt={imgAlt} isOldImage />
                </>
            );
        }
        return null;
    };

    const renderImageSectionMobile = () => {
        if (isMobile && isTablet) {
            return (
                <>
                    <Shapes
                        isPair
                        isDark
                        degrees="-26.87deg"
                        speed={0.08}
                        smallMargins={{ width: 65.24, height: 32.62 }}
                        largeMargins={{ width: 112.21, height: 56.1 }}
                        distanceBetween={{ width: '0%', height: '15%' }}
                        containerMargins={{ left: '-10%', top: '25%' }}
                        zIndex={0}
                    />
                    <Image className='mobile-app-section-icon-message'
                        src="/assets/images/message-icon.png"
                        alt={imgAlt}
                        isMobile
                        isOldImage
                    />
                    <Image className='mobile-app-section-icon-image'
                        src="/assets/images/wallet-icon.png"
                        alt={imgAlt}
                        isMobile
                        isOldImage
                    />
                </>
            );
        }
        return null;
    };

    const renderImageSection = () => {
        return (
            <div className='hero-section-image-container'>
                {renderImageSectionDesktop()}
                {renderImageSectionMobile()}
                <Image className='mobile-app-section-image' src={imgSrc} alt={imgAlt} isOldImage />
            </div>
        );
    };

    return (

        <div className='main-grid-container mobile-app-section-grid-container'>

            <div className='main-grid-item main-grid-md-6 mobile-app-section-image-grid-container'>
                {renderImageSection()}
            </div>

            <div className='main-grid-item main-grid-md-6 mobile-app-section-text-grid-container'>

                <FadeInAnimation>

                    <div className='mobile-app-section-text-container'>

                        <h4 className='mobile-app-section-title'>{props.title}</h4>

                        <p className='mobile-app-section-paragraph'>{props.paragraph}</p>

                        <div>

                            <a
                                href="//play.google.com/store/apps/details?id=za.co.homii.mobile&hl=en"
                                rel="noreferrer"
                                target="_blank"
                                aria-label="google play"
                            >
                                <img
                                    src="/assets/images/google_play.png"
                                    alt="Google Play"
                                    className="app-download-buttons"
                                />
                            </a>

                            <a
                                href="//apps.apple.com/za/app/homii-lifestyle/id1478894335"
                                rel="noreferrer"
                                target="_blank"
                                aria-label="apple store"
                            >
                                <img
                                    src="/assets/images/apple.png"
                                    alt="Play Store"
                                    className="app-download-buttons"
                                />
                            </a>
                            <a
                                href="//appgallery.huawei.com/#/app/C102716343"
                                rel="noreferrer"
                                target="_blank"
                                aria-label="huawei appgallery"
                            >
                                <img
                                    src="/assets/images/huawei.png"
                                    alt="Huawei Store"
                                    className="app-download-buttons"
                                />
                            </a>

                        </div>

                    </div>

                </FadeInAnimation>

            </div>

        </div>
    );
};

export default MobileAppSection;

MobileAppSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
    imgAlt: PropTypes.string,
    imgSrc: PropTypes.string,
};

